import { useEffect, useState } from 'react';
import {
  setLocalStorageValue,
  prefixStorageKey,
} from '@antimatterhq/ui/utils/localStorage';

export function useLocalStorageSyncedState<T>(
  localStorageKey: string,
  subKey: string,
  initialState: T,
  persistState: boolean = true,
) {
  const [state, setState] = useState<T>(initialState);

  useEffect(() => {
    if (persistState) {
      setLocalStorageValue(prefixStorageKey(localStorageKey, subKey), state);
    }
  }, [localStorageKey, state, subKey, persistState]);

  return [state, setState] as const;
}
